import { z } from 'zod';

const normalizeCPF = (cpf: string) => cpf.replace(/\D/g, '');

type CPFEntry = {
  cpf?: string;
  path: (string | number)[];
};

export function validateDuplicateCPFs(
  entries: CPFEntry[],
  ctx: z.RefinementCtx,
): void {
  const cpfMap = new Map<string, (string | number)[][]>();

  entries.forEach(({ cpf, path }) => {
    if (!cpf) return;

    const normalized = normalizeCPF(cpf);

    if (!normalized) return;

    if (!cpfMap.has(normalized)) cpfMap.set(normalized, []);
    cpfMap.get(normalized)!.push(path);
  });

  cpfMap.forEach(paths => {
    if (paths.length > 1) {
      paths.forEach(path => {
        ctx.addIssue({
          code: 'custom',
          message: 'CPF já foi informado',
          path,
        });
      });
    }
  });
}
